import { adminConstants } from "../constant/admin-constant";
import { alertActions } from "./alert-actions";
import { createOrderService } from "../../services/createOrder";
import { history } from "helper/history";

export const createOrderActions = {
    getOrderSteps,
    getOrderFilterValues,
    getProducts,
    addProductsToCart,
    getCartProductsPagination,
    getOrderProductsPagination,
    deleteProductFromCart,
    placeOrder,
    getOrderAttributes,
    getOrdersList,
    saveCart,
    saveOrder,
    saveOrderStatus,
    getCustomerBrandsList,
    getCartsList,
    getCart,
    updateCartProduct,
    getOrderStates,
    getOrderStatesForBrand
};

function getCustomerBrandsList(for_order) {
    return dispatch => {
        return createOrderService
            .getCustomerBrands(for_order)
            .then(brandsData => {
                dispatch({
                    type: adminConstants.GET_CUSTOMER_BRANDS_FOR_CREATE_ORDER_SUCCESS,
                    payload: brandsData
                });
                return brandsData;
            });
    };
}

function getCart(id) {
    return dispatch => {
        return createOrderService
            .getCart(id)
            .then(
                response => {
                    return response.result;
                    // dispatch({
                    //     type: adminConstants.GET_CART_DETAILS_SUCCESS,
                    //     payload: response.result
                    // });
                },
                error => {
                    dispatch(alertActions.error(error));
                    return Promise.reject(error);
                }
            );
    };
}

function getCartsList(page, filter, pageSize) {
    return dispatch => {
        return createOrderService
            .getCartsList(
                page,
                filter,
                pageSize
            )
            .then(
                response => {
                    dispatch({
                        type: adminConstants.PAGINATION_CARTS_SUCCESS,
                        payload: response.result
                    });
                },
                error => {
                    dispatch(alertActions.error(error));
                    return Promise.reject(error);
                }
            );
    };
}

function getOrdersList(id, page, pageSize, sort, pagination, data) {
    return dispatch => {
        return createOrderService
            .getOrdersList(
                id,
                page,
                pageSize,
                sort,
                pagination,
                data
            )
            .then(
                response => {
                    dispatch({
                        type: adminConstants.PAGINATION_ORDERS_SUCCESS,
                        payload: response.result
                    });
                    return response.result.orders;
                },
                error => {
                    dispatch(alertActions.error(error));
                    return Promise.reject(error);
                }
            );
    };
}

function getOrderAttributes(id) {
    return dispatch => {
        return createOrderService.getOrderAttributes(id).then(
            response => {
                dispatch({
                    type: adminConstants.GET_ORDER_ATTRIBUTES_SUCCESS,
                    payload: response.result
                });
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function placeOrder(data) {
    return dispatch => {
        return createOrderService.placeOrder(data).then(
            response => {
                if (response.status !== 'error') {
                    dispatch(alertActions.success("Order placed!"));
                    history.push("/Admin/order-list");
                }
                else {
                    dispatch(alertActions.error(response.message));
                }
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function saveOrder(data) {
    return dispatch => {
        return createOrderService.saveOrder(data).then(
            response => {
                if (response.status !== 'error') {
                    dispatch(alertActions.success("Order changes saved!"));
                    history.push("/Admin/order-list");
                }
                else {
                    dispatch(alertActions.error(response.message));
                }
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function saveOrderStatus(data) {
    return dispatch => {
        return createOrderService.saveOrderStatus(data).then(
            response => {
                dispatch(alertActions.success("Order status changed!"));
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function saveCart(data) {
    return dispatch => {
        return createOrderService.saveCart(data).then(
            response => {
                dispatch(alertActions.success("Cart saved successfully!"));
                return response;
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function deleteProductFromCart(data) {
    return dispatch => {
        return createOrderService.deleteProductFromCart(data).then(
            response => {
                return response;
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function getOrderSteps(id) {
    return dispatch => {
        return createOrderService.getOrderSteps(id).then(
            response => {
                return response;
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function getOrderFilterValues(data) {
    return dispatch => {
        return createOrderService
            .getOrderFilterValues(data)
            .then(
                response => {
                    return response;
                },
                error => {
                    dispatch(alertActions.error(error));
                    return Promise.reject(error);
                }
            );
    };
}

function getProducts(data) {
    return dispatch => {
        return createOrderService.getProducts(data).then(
            response => {
                return dispatch({
                    type: adminConstants.GET_FILTERED_PRODUCTS_SUCCESS,
                    payload: response.result.productsdata
                });
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function getCartProductsPagination(data) {
    return dispatch => {
        return createOrderService.getCartProducts(data).then(
            response => {
                dispatch({
                    type: adminConstants.GET_FILTERED_PRODUCTS_SUCCESS,
                    payload: response.result
                });
                return response.result;
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function getOrderProductsPagination(data) {
    return dispatch => {
        return createOrderService.getOrderProducts(data).then(
            response => {
                dispatch({
                    type: adminConstants.GET_ORDER_PRODUCTS_SUCCESS,
                    payload: response.result
                });
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function addProductsToCart(data) {
    return dispatch => {
        return createOrderService.addProductsToCart(data).then(
            response => {
                dispatch({
                    type: adminConstants.ADD_PRODUCTS_TO_CART_SUCCESS,
                    payload: response
                });
                dispatch(alertActions.success("Cart changes done!"));
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function updateCartProduct(data) {
    return dispatch => {
        return createOrderService.updateCartProduct(data).then(
            response => {
                return response;
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function getOrderStates(id) {
    return dispatch => {
        return createOrderService.getOrderStates(id).then(
            response => {
                return response;
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function getOrderStatesForBrand(id) {
    return dispatch => {
        return createOrderService.getOrderStatesForBrand(id).then(
            response => {
                return response;
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}



// WEBPACK FOOTER //
// ./src/redux/actions/create-order-actions.jsx